import typesEdit from '@/views/types/edit'
import typesList from '@/views/types/list'

export default [
  {
    path: '/tipos',
    name: 'typesList',
    component: typesList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'types',
      heading: 'menu.types',
      auth: true,
      roles: [
        {
          create:  ['super-admin'],
          edit: ['super-admin'],
          remove: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/tipos/novo',
    name: 'typesCreate',
    component: typesEdit,
    meta: {
      layout: 'sidebar',
      base: 'types',
      heading: 'menu.types',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/tipos/:id/editar',
    name: 'typesUpdate',
    component: typesEdit,
    meta: {
      layout: 'sidebar',
      base: 'types',
      heading: 'menu.types',
      auth: true,
      roles: ['super-admin']
    }
  }
]
